<script>
import PriceModifierField from './PriceModifierField';
import Popper from 'popper.js';

export default {
    props: ['start', 'end', 'modifier', 'products'],
    components: { PriceModifierField },
    data() {
        return {
            visible: true,
            modifierPopper: null,
        };
    },
    created() {
        this.$nextTick(function () {
            new Popper(document.querySelectorAll('.fc-highlight')[0], this.$refs.modifierPopper, {
                preventOverflow: {
                    boundariesElement: $('#dynamicPricingCalendar')[0],
                },
            });

            Bus.$on('hidePriceModifierField', this.hide);
            Bus.$on('priceModifierSaved', this.hide);

            this.show();
        });
    },
    beforeDestroy() {
        Bus.$off('hidePriceModifierField', this.hide);
        Bus.$off('priceModifierSaved', this.hide);
    },
    methods: {
        hide() {
            this.visible = false;
        },
        show() {
            this.visible = false;
            this.$nextTick(() => {
                this.visible = true;
            });
        },
    },
};
</script>

<style lang="css" scoped>
.popper {
    min-width: 300px;
}
</style>
